import { dto_common } from "../../../../classes/dto-common";
import "../../../../styles/css/pg-product.css";

function PgProductImage({
  imageUrl = String,
  onImageError = () => {},
}) {
  return (
    <img
      loading="lazy"
      className="pgProductImg"
      src={imageUrl}
      onError={(e) => {
        e.currentTarget.style.display = "none";
        e.currentTarget.src = dto_common.DefaultImageUrl;
        onImageError();
      }}
      alt=""
    />
  );
}
export default PgProductImage;
